import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "0c1ee32e-15ce-4dbe-870e-32af45e7c2ed",
    authority: "https://login.microsoftonline.com/3ba1c437-9a2d-41c2-a5f7-2fcfd6217183",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:   console.error(message); return;
          case LogLevel.Warning: console.warn(message);  return;
          default: return;
        }
      },
      logLevel: LogLevel.Warning,
    },
    allowNativeBroker: false,
  },
};

// Scopes for initial login (identity only)
export const loginRequest = {
  scopes: ["User.Read"],
};

